//Used for file upload step, table in the file upload stepper dialogue
export const UploadFileTableHeaderColumn = [
  { id: "Title", label: "EditedFileTitle" },
  { id: "Original_title", label: "OriginalFileTitle" },
  { id: "File_type", label: "FileType" },
  { id: "File_category", label: "FileCategory" },
];
export const UploadFileTableHeaderTrimColumns = [
  "Title","Original_title"
];